import { Pageable } from "./pageable.model";
import { Sort } from "./sort.model";


export class PageOfContentCast {
  constructor(
    public content?: ContentCast[],
    public empty?: boolean,
    public first?: boolean,
    public last?: boolean,
    public number?: number,
    public numberOfElements?: number,
    public pageable?: Pageable,
    public size?: number,
    public sort?: Sort,
    public totalElements?: number,
    public totalPages?: number,
  ) {}
}
export class ContentCastIds {
  constructor(
    public id?: number
  ) {}
}

export class ContentCastPoster {
  constructor(public id?: number, public isDefault?: boolean, public url?: string, public cast?: ContentCast) {}
}


// PageOfContentCast {
//   content (Array[ContentCast], optional),
//   empty (boolean, optional),
//   first (boolean, optional),
//   last (boolean, optional),
//   number (integer, optional),
//   numberOfElements (integer, optional),
//   pageable (Pageable, optional),
//   size (integer, optional),
//   sort (Sort, optional),
//   totalElements (integer, optional),
//   totalPages (integer, optional)
//   }

export class ContentCast {
  constructor(
    public id?: number,
    public name?: string,
    public posterUrl?: string,
    public type?: string,
    public code?: string,
    public imdbId?:string
  ) {}
}

